// מדידת פניות וואטסאפ מכל קישור wa.me באתר (הכפתור הצף + כפתורים בתוך הדפים).
// מאזין אחד ברמת המסמך, כך שקישור וואטסאפ חדש נמדד אוטומטית בלי לגעת בקוד שלו.
// תווית ידנית: data-wa-label="..." על הקישור; אחרת נלקח הטקסט של הכפתור.
import { getAiSource } from "./aiReferral";

// לחיצה על "נסי בחינם" (מעבר להרשמה באפליקציה) ולחיצה על טלפון — אותו מאזין.
function ctaLabel(link, fallback) {
  return (link.innerText || "").replace(/\s+/g, " ").trim().slice(0, 60) || fallback;
}

function handleClick(e) {
  if (typeof window.gtag !== "function" || !e.target.closest) return;

  const signup = e.target.closest('a[href*="MainPageToConnect/CreateBusinessAccount"]');
  if (signup) {
    window.gtag("event", "signup_click", {
      event_category: "conversion",
      event_label: ctaLabel(signup, "signup_link"),
      page_path: window.location.pathname,
      ai_source: getAiSource(),
    });
    return;
  }

  const phone = e.target.closest('a[href^="tel:"]');
  if (phone) {
    window.gtag("event", "phone_click", {
      event_category: "conversion",
      event_label: ctaLabel(phone, "phone_link"),
      page_path: window.location.pathname,
      ai_source: getAiSource(),
    });
    return;
  }

  const link = e.target.closest('a[href*="wa.me"]');
  if (!link) return;

  const label =
    link.dataset.waLabel ||
    (link.innerText || "").replace(/\s+/g, " ").trim().slice(0, 60) ||
    "whatsapp_link";

  window.gtag("event", "whatsapp_click", {
    event_category: "conversion",
    event_label: label,
    page_path: window.location.pathname,
    ai_source: getAiSource(),
  });
}

// נקרא פעם אחת ב-_app. מחזיר פונקציית ניקוי.
export function initWhatsAppTracking() {
  document.addEventListener("click", handleClick, true);
  return () => document.removeEventListener("click", handleClick, true);
}
